import { DateRangeFilter } from "./DateRangeFilter";

export function ReportSummaryHeader({ timeRange, onTimeRangeChange }) {
  return (
    <div className="flex items-center justify-between">
      <div>
        <span className="text-[#1A1A1A] text-xl">Report Summary</span>
        <p className="text-[#6B7280]">
          Overview of all revenue streams and key metrics
        </p>
      </div>
      <DateRangeFilter value={timeRange} onChange={onTimeRangeChange} />
    </div>
  );
}
